"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesImportMapHeader = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const router_1 = require("client/components/router");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/sites/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
const alert_1 = require("../../../../components/ui/alert");
require("./sites-import-map-header.less");
let SitesImportMapHeader = class SitesImportMapHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.columnsHeader = [];
        this.dataToPersist = [];
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.invalidMapping = false;
        this.databaseColumnsHeader = [
            // #TK these headers reflect the headers from the database
            "address",
            "city",
            "deaLicense",
            "fax",
            "live",
            "name",
            "displayName",
            "ncpdpId",
            "notes",
            "npiNumber",
            "phone",
            "state",
            "zip",
            "timezone"
        ];
        this.mappedHeadersObject = {};
        this.mappedHeadersArray = [];
        this.siteId = null;
        this.handleOnDragEnd = (event) => {
            // console.log("handleOnDragEnd triggered");
            event.target.classList.toggle("drag-accent");
            // change opacity back to 1 on drag end
            event.target.style.opacity = "1";
        };
        this.handleOnDragStart = (event) => {
            // console.log("handleOnDragStart triggered");
            event.dataTransfer.setData("text", event.target.innerText);
            event.dataTransfer.setData("elementId", event.target.id);
            event.dataTransfer.setData("elementParentId", event.target.parentElement.id);
            event.target.classList.toggle("drag-accent");
            event.target.parentNode.classList.remove("drag-over-accent"); // #TK remove accent class from drop zone.
            // change opacity on drag start
            event.target.style.opacity = "0.4";
        };
        this.handleOnDrop = (event) => {
            event.preventDefault();
            event.stopPropagation();
            // console.log("handleOnDrop triggered");
            const child = document.getElementById(event.dataTransfer.getData("elementId"));
            // #TK add triangle tooltip on link
            if (event.target.classList.contains("droppable")) {
                event.target.appendChild(child);
            }
            else {
                const oldElement = event.target;
                const newElement = document.getElementById(event.dataTransfer.getData("elementId"));
                const dropArea = event.target.parentElement;
                const newElementOldParent = document.getElementById(event.dataTransfer.getData("elementParentId"));
                dropArea.removeChild(oldElement);
                dropArea.appendChild(newElement);
                newElementOldParent.appendChild(oldElement);
            }
            this.renderAccentToolTip();
            return false;
        };
        this.renderAccentToolTip = () => {
            const importMapArea = document.getElementsByClassName("mapping-container__drop-area");
            try {
                [...importMapArea].forEach(area => {
                    if (area && area.children) {
                        const children = [...area.children];
                        if (children) {
                            children.forEach(child => child.classList.add("link-accent"));
                        }
                    }
                });
                const importHeaderContainer = document.getElementById("import-header-container");
                if (importHeaderContainer && importHeaderContainer.children) {
                    [...importHeaderContainer.children].forEach(child => child.classList.remove("link-accent"));
                }
            }
            catch (e) {
                console.log("error on renderaccenttooltip", e);
            }
        };
        this.handleOnDragEnter = (event) => false;
        this.handleOnDragOver = (event) => {
            // console.log("handleOnDragOver triggered");
            event.preventDefault();
            if (event.target.classList.contains("mapping-container__drop-area")) {
                event.target.classList.add("drag-over-accent");
            }
            return false;
        };
        this.handleOnDragExit = (event) => {
            // console.log("handleOnDragExit triggered");
            // event.preventDefault();
        };
        this.handleOnDragLeave = (event) => {
            // console.log("handleOnDragLeave triggered");
            if (event.target.classList.contains("mapping-container__drop-area")) {
                event.target.classList.remove("drag-over-accent");
            }
            return false;
        };
        this.handleOnPreview = () => {
            // console.log("handleOnPreview triggered");
            const mappedHeaders = document.getElementsByClassName("mapping-container");
            // parse mapped header relationships from HTMLCollection
            [...mappedHeaders].forEach((mappedHeader) => {
                const importHeader = mappedHeader.querySelector(".import-header");
                if (importHeader) {
                    const importKey = importHeader.dataset.headerName.trim();
                    const dbKey = mappedHeader.children[1].innerText
                        .replace(/(\r\n|\n|\r)/gm, "")
                        .trim();
                    this.mappedHeadersObject[dbKey] = importKey;
                }
            });
            // this.checkValidMapping();
            // if (this.invalidMapping) {
            //   return;
            // }
            store_1.sitesStore.mappedHeadersObject = this.mappedHeadersObject;
            // console.log("before preview ------ ", this.mappedHeadersObject);
            router_1.RouteManager.transitionTo("/pharmacies/import/preview");
        };
        this.handleOnCancel = () => {
            console.log("handleOnCancel triggered");
        };
        this.checkValidMapping = () => {
            // console.log("checkValidMapping triggered");
            for (const header in this.mappedHeadersObject) {
                if (this.mappedHeadersObject[header] === "") {
                    this.invalidMapping = true;
                }
            }
        };
        this.renderImportHeaders = () => this.columnsHeader.map((dataColumn, i) => (React.createElement("div", { style: { whiteSpace: "pre" }, className: "import-header", key: i, "data-header-name": dataColumn, id: `draggable-import-header-${i}`, draggable: true, onDragStart: this.handleOnDragStart, onDragEnd: this.handleOnDragEnd }, dataColumn)));
        this.renderDatabaseHeaders = () => this.databaseColumnsHeader.map((dataColumn, i) => (React.createElement("div", { className: "mapping-container", key: i },
            React.createElement("div", { id: `mapping-container__drop-area-${i}`, "data-name": dataColumn, className: "mapping-container__drop-area droppable", onDragEnter: this.handleOnDragEnter, onDragLeave: this.handleOnDragLeave, onDragOver: this.handleOnDragOver, onDragExit: this.handleOnDragExit, onDrop: this.handleOnDrop }),
            React.createElement("div", { className: "mapping-container__database-header" }, dataColumn))));
        this.mapIdenticalHeaders = () => {
            // console.log("mapIdenticalheader triggered");
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            // [...importHeaders].forEach((header: HTMLElement) => {
            //   const headerText = header.innerText;
            //   if (this.databaseColumnsHeader.includes(headerText)) {
            //     const dropArea = databaseHeaderPaper.querySelector(
            //       `[data-name=${headerText}]`,
            //     );
            //     dropArea.appendChild(header);
            //   } else {
            //     console.log('does not include', headerText);
            //   }
            // });
            // const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header =>
            //   header.replace(/\s+/g, '').toLowerCase(),
            // );
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            [...importHeaders].forEach((header) => {
                const headerText = header.innerText;
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                // console.log("headerTextParsed is ", headerTextParsed);
                if (databaseColumnsHeaderParsed.includes(headerTextParsed)) {
                    const index = databaseColumnsHeaderParsed.indexOf(headerTextParsed);
                    const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                    dropArea.appendChild(header);
                }
                else {
                    console.log("does not include", headerText);
                }
            });
            this.renderAccentToolTip();
        };
        // handle a redirect if no siteId selected -- make it so user cannot navigate to page.
        this.handleAuthRedirect = () => {
            // console.log("handleAuthRedirect triggered");
            if (!this.siteId) {
                router_1.RouteManager.transitionTo("/sites");
            }
        };
    }
    componentWillReceiveProps() {
        // console.log("cwrp triggered");
        this.columnsHeader = store_1.sitesStore.importColumnsHeader.map(header => header.trim());
        // console.log("this.columnsHeader is", this.columnsHeader);
    }
    componentWillMount() {
        // console.log("cdm triggered");
        if (store_1.sitesStore.importColumnsHeader &&
            store_1.sitesStore.importColumnsHeader.length) {
            this.columnsHeader = store_1.sitesStore.importColumnsHeader.map(header => header.trim());
        }
        else {
            this.columnsHeader = [];
        }
        this.databaseColumnsHeader.forEach(header => (this.mappedHeadersObject[header] = ""));
    }
    componentDidMount() {
        // console.log("componentDidMount triggered");
        store_1.sitesStore.dbHeaders = this.databaseColumnsHeader;
        this.mapIdenticalHeaders();
    }
    render() {
        {
            this.columnsHeader.length && this.mapIdenticalHeaders();
        }
        return (React.createElement(react_1.Fragment, null,
            React.createElement("section", { className: "header-container--map" },
                React.createElement("div", { className: "header-paper" },
                    this.invalidMapping && (React.createElement(alert_1.UiAlert, { type: "warning", message: "Some of the mapping fields are missing", dismissable: true, onRequestDismiss: () => (this.invalidMapping = false) })),
                    React.createElement("div", { className: "header-paper__message" },
                        React.createElement("h1", null, "Please map the headers"),
                        React.createElement("div", null,
                            React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/pharmacies/import/select" }, "Back"),
                            React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleOnPreview }, "Preview"))),
                    React.createElement("div", { className: "header-paper__container" },
                        React.createElement("div", { className: "header-paper__import" },
                            React.createElement("div", { id: "import-header-container", className: "import-header-container droppable", onDragOver: this.handleOnDragOver, onDrop: this.handleOnDrop }, this.renderImportHeaders())),
                        React.createElement("div", { id: "database-header-paper", className: "header-paper__database" },
                            React.createElement("div", { className: "database-header-container" }, this.renderDatabaseHeaders()))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Make changes", message: `Please confirm you have mapped the correct headers.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: () => alert("confirmed"), title: "Confirm header mappings" }))));
    }
};
__decorate([
    mobx_1.observable
], SitesImportMapHeader.prototype, "columnsHeader", void 0);
__decorate([
    mobx_1.observable
], SitesImportMapHeader.prototype, "dataToPersist", void 0);
__decorate([
    mobx_1.observable
], SitesImportMapHeader.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], SitesImportMapHeader.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], SitesImportMapHeader.prototype, "invalidMapping", void 0);
SitesImportMapHeader = __decorate([
    mobx_react_1.observer
], SitesImportMapHeader);
exports.SitesImportMapHeader = SitesImportMapHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-import-map-header/sites-import-map-header.tsx
// module id = 4081
// module chunks = 0